module.exports = __webpack_public_path__ + "media/app/google-play-badge-fr-b90d95fa.svg";